const OPEN_ATTRIBUTE = 'data-dropdown-header-open';

export class GlobalHeader {
   toggleHeaderDropdown(dropdownContainer, forceShow) {
      let dropdown = dropdownContainer.querySelector('.header-dropdown');
      let isOpen = dropdownContainer.hasAttribute(OPEN_ATTRIBUTE);

      if (forceShow !== undefined && forceShow === isOpen) {
         return;
      }

      if (isOpen) {
         dropdownContainer.removeAttribute(OPEN_ATTRIBUTE);
         dropdown.style.transition = 'transform 400ms linear';
         dropdown.style.transform = 'translateY(-100%)';
         setTimeout(() => {
            dropdownContainer.classList.remove('dropdown-container-active');
            dropdown.style.transition = '';
            dropdown.style.transform = '';
         }, 400);
      } else {
         this.closeOpenHeaderDropdowns();
         dropdownContainer.setAttribute(OPEN_ATTRIBUTE, '');
         dropdownContainer.classList.add('dropdown-container-active');
         dropdown.style.transition = 'transform 200ms linear';
         requestAnimationFrame(() => {
            dropdown.style.transform = 'translateY(0%)';
         });
      }
   }

   setupHeaderDropdown(toggleButton, dropdown, options = {}) {
      if (!toggleButton || !dropdown) {
         return;
      }

      // Toggle the dropdown if the toggle button is clicked. Stop the process
      // if an 'unlock' boolean function is passed in and returns false.
      toggleButton.addEventListener('click', ev => {
         if (options.unlock && !options.unlock()) {
            return;
         }
         options.onFirstOpen && options.onFirstOpen();
         delete options.onFirstOpen;
         ev.preventDefault();
         ev.stopPropagation();
         this.toggleHeaderDropdown(dropdown);
      });

      // Close the dropdown when clicking outside of it.
      window.addEventListener('click', ev => {
         if (!(dropdown.contains(ev.target) || toggleButton.contains(ev.target))) {
            this.toggleHeaderDropdown(dropdown, false);
         }
      });
   }

   closeOpenHeaderDropdowns() {
      document.querySelectorAll(`[${OPEN_ATTRIBUTE}]`).forEach(dropdown => {
         this.toggleHeaderDropdown(dropdown, false);
      });
   }

   showLoggedIn(info) {
      let loggedInNav = document.querySelector('#loggedInNav');
      if (!loggedInNav) {
         return;
      }
      let firstName = info.username.replace(/\s+.*$/, '');
      document.querySelector('#menuUsername').textContent = firstName;
      document.querySelector('#loggedOutNav').style.display = 'none';
      loggedInNav.style.display = '';
   }

   showLoggedOut() {
      let loggedInNav = document.querySelector('#loggedInNav');
      if (!loggedInNav) {
         return;
      }
      loggedInNav.style.display = 'none';
      document.querySelector('#loggedOutNav').style.display = '';
   }
}
